/**
 * Supports existing native card deeplinks (also emitted by Money Coach) that
 * web historically only partially accepted. Remap aliases to the canonical
 * Investment Detail path `/cards/:cardUuid`. Returns null when the URL should
 * fall through (e.g. bare `/cards` → handled by the investments redirect).
 *
 * STASH2026-13746
 */
export function resolveCardDeeplink(
	pathname: string,
	search: string
): string | null {
	const id = new URLSearchParams(search).get('id');

	if ((pathname === '/card' || pathname === '/cards') && id) {
		return `/cards/${id}`;
	}

	const pathMatch = pathname.match(/^\/card\/([^/]+)$/);
	if (pathMatch) {
		return `/cards/${pathMatch[1]}`;
	}

	return null;
}
